import React from 'react'
import { Global, css } from '@emotion/core'
import { withTheme } from 'emotion-theming'
import 'common/styles/css/sanitize.css'
import 'common/styles/fonts/gilroy.css'

const GlobalStyles = withTheme(({ theme }) => (
  <Global
    styles={css`
      ::-webkit-scrollbar {
        width: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: ${theme.white};
      }
      ::-webkit-scrollbar-track {
        background-color: ${theme.black};
      }

      body,
      html,
      #root {
        margin: 0;
        padding: 0;
        width: 100%;
        font-size: 16px;
        line-height: 150%;
        height: 100vh;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      #root {
        display: flex;
        align-items: stretch;
      }

      body {
        font-family: 'Gilroy';
        background-color: ${theme.blueMedium};
        color: ${theme.white};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-variant-numeric: tabular-nums;
        overscroll-behavior: none;
      }

      input,
      button {
        font-family: 'Gilroy';
        margin: 0;
        padding: 0;
      }

      * {
        box-sizing: border-box;
      }
    `}
  />
))

export default GlobalStyles
